import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=f611ef1a&scoped=true"
import script from "./saleDetail.vue?vue&type=script&lang=js"
export * from "./saleDetail.vue?vue&type=script&lang=js"
import style0 from "./saleDetail.vue?vue&type=style&index=0&id=f611ef1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f611ef1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f611ef1a')) {
      api.createRecord('f611ef1a', component.options)
    } else {
      api.reload('f611ef1a', component.options)
    }
    module.hot.accept("./saleDetail.vue?vue&type=template&id=f611ef1a&scoped=true", function () {
      api.rerender('f611ef1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/saleDetail.vue"
export default component.exports